import React from 'react';
import '../styles/HomeHeaderStyle.css';
import LoginLogout from '../login/LoginLogout';


function Header() {
  return (
    <div className='headerDiv'>
      <p id='Version'>Ver. 1.0</p>
      <div className='logoAndTitle'>
      <h1 className='title'>Chimera</h1>
      <img src="/images/moon.png" alt="moon" id='logo' onClick={console.log("WW91IGFyZSBJbmZpbml0ZQ==")}/>
      <h1 className='title'>Project</h1>
      </div>
      <LoginLogout/>


      
    </div>
  )
}

export default Header
